import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const getUsers = (params) => ({
  type: actionTypes.GET_USERS,
  params
});

export const getUser = (params) => ({
  type: actionTypes.GET_USER,
  params
});

export const createUser = (payload) => ({
  type: actionTypes.CREATE_USER,
  payload
});

export const updateUser = (payload) => ({
  type: actionTypes.UPDATE_USER,
  payload
});

export const deleteUser = (Id) => ({
  type: actionTypes.DELETE_USER,
  Id
});

export const updateUserStatus = (Id) => ({
  type: actionTypes.UPDATE_USER_STATUS,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});

export const getUserRoles = () => ({
  type: actionTypes.GET_USER_ROLES,
});
